// extracted by mini-css-extract-plugin
export default {"price-input":"_3YXiZ","priceInput":"_3YXiZ","premium-selected":"_3JKFC","premiumSelected":"_3JKFC"};